import { gql, TypedDocumentNode } from 'apollo-angular';

import {
  IListMessagesByRoomInput,
  IListMessagesByRoomResult,
} from '@shared/models/messages';

export const ROOM_MESSAGE_FRAGMENT = gql`
  fragment RoomMessageFragment on RoomMessage {
    id

    fromFullName
    subjectPreview
    notificationPreview
    seen
    generalRoom {
      id
      userId
      subject
    }
    propertyRoom {
      id
      userId
      propertyId
      property {
        id
        fullAddress
      }
    }
    updatedAt
  }
`;

export const LIST_MESSAGES_BY_ROOM: TypedDocumentNode<
  IListMessagesByRoomResult,
  IListMessagesByRoomInput
> = gql`
  query listMessagesByRoom($sort: [RoomMessageSortInput]) {
    listMessagesByRoom(sort: $sort) {
      count
      results {
        ...RoomMessageFragment
      }
    }
  }
  ${ROOM_MESSAGE_FRAGMENT}
`;
